import { ref } from 'vue'

export const seamlessPageTransitionFlag = Symbol('seamless-page-transition-flag')
export const shouldSavePagePosition = ref(false)
